@if (active() === receiptTypeCodes.Delivery) {
  <sd-delivery-address-block />

  @if (addressCityMatches(); as cities) {
    @if (cities.length) {
      <div class="wrong-city">
        <div class="wrong-city-info color-black">
          <sd-icon class="icon-size-s" [type]="iconTypes.ATTENTION"></sd-icon>
          <span class="text-b3-s-300">город в адресе не соответствует текущему городу</span>
          @for (city of cities; track $index) {
            <button
              (click)="setCorrectionCity(city.point)"
              type="button"
              class="btn-icon color-black-warm text-b4-m-300"
            >
              я в г. {{ city.name }}
            </button>
          }
        </div>
      </div>
    }
  }
} @else if (active() === receiptTypeCodes.Pickup) {
  <sd-pickup-address></sd-pickup-address>
} @else {
  <div class="receipt-address sd-group-skeleton-gradient-wave">
    <div class="receipt-address-label sd-skeleton"></div>
    <div class="receipt-address-content sd-skeleton"></div>
  </div>
}
